// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__cJi3R","spin":"Loader_spin__R7a60"};